var angular = require('angular');
var template = require('./template.pug')();

 angular
  .module("app.directives")
  .directive('editBtn', function($compile){
    return {
      restrict: 'A',
      scope: {
        open: '&editBtn'
      },
      link: function(scope, element, attrs){
        scope.isImage = (element[0].tagName === 'IMG');

        var compiled = $compile(template)(scope);

        if (scope.isImage) {
          element.wrap('<div class="btn-inline-wrap"></div>');
          element.after(compiled);
        } else {
          element.append(compiled);
        }

        element.addClass('btn-inline-root');
      }
    }
  })
